var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCheckFat = function SvgCheckFat(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#FBF9F2",
    rx: 8
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F8CE64",
    d: "m18.058 9.788-6.64 6.42a.84.84 0 0 1-.585.234.84.84 0 0 1-.585-.234l-3.703-3.6a.79.79 0 0 1-.242-.565c0-.212.087-.415.242-.565l1.034-1a.84.84 0 0 1 .584-.233c.219 0 .429.084.584.233l2.107 1.976 5.004-4.778a.84.84 0 0 1 .584-.234c.219 0 .429.084.584.234l1.032.976a.8.8 0 0 1 .245.568.78.78 0 0 1-.245.568"
  })));
};
export default SvgCheckFat;